module.exports = __webpack_public_path__ + "img/warning.07668a45.svg";